import { render } from "./ResentSermon.vue?vue&type=template&id=50d9d762&scoped=true"
import script from "./ResentSermon.vue?vue&type=script&lang=js"
export * from "./ResentSermon.vue?vue&type=script&lang=js"

import "./ResentSermon.vue?vue&type=style&index=0&id=50d9d762&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d9d762"]])

export default __exports__